import { useGetAllUserPlaylistProgressQuery } from '../../../../__generated__/chirp/com/hubspot/learning/center/credentials/rpc/PlaylistVisibilityChirpService.hooks';
import { DEFAULT_PAGE_SIZE } from '../constants/pagination';
import I18n from 'I18n';
export const useRecentCompletedPlaylists = () => {
  const {
    data,
    loading,
    error
  } = useGetAllUserPlaylistProgressQuery({
    variables: {
      sortOrder: 'DESC',
      sortField: 'COMPLETED_DATE',
      offset: {
        offsetPosition: 0
      },
      pageLength: 25,
      status: 'COMPLETED'
    }
  });
  return {
    recentCompletedPlaylists: data === null || data === void 0 ? void 0 : data.results,
    recentCompletedPlaylistsLoading: loading,
    recentCompletedPlaylistsError: error
  };
};
export const useIncompletePlaylists = () => {
  const today = I18n.moment.userTz().startOf('day');
  const oneMonthFromToday = I18n.moment.userTz().startOf('day').add(1, 'month');
  const {
    data,
    loading,
    error
  } = useGetAllUserPlaylistProgressQuery({
    variables: {
      sortOrder: 'ASC',
      sortField: 'DUE_DATE',
      offset: {
        offsetPosition: 0
      },
      pageLength: 25,
      status: 'INCOMPLETE',
      dueDate: {
        startDate: today.valueOf(),
        endDate: oneMonthFromToday.valueOf()
      }
    }
  });
  return {
    incompletePlaylists: data === null || data === void 0 ? void 0 : data.results,
    incompletePlaylistsLoading: loading,
    incompletePlaylistsError: error
  };
};
export const usePlaylistAssignments = ({
  pageLength = DEFAULT_PAGE_SIZE,
  offset = 0,
  sortOrder = 'ASC',
  sortField = 'PLAYLIST_NAME',
  playlistNameQuery,
  teams,
  users
}) => {
  const {
    data,
    loading,
    error
  } = useGetAllUserPlaylistProgressQuery({
    variables: Object.assign({
      sortOrder,
      sortField
    }, playlistNameQuery ? {
      playlistNameQuery
    } : {}, teams && teams.length > 0 ? {
      teams
    } : {}, users && users.length > 0 ? {
      teamMembers: users
    } : {}, {
      offset: {
        offsetPosition: offset
      },
      pageLength
    })
  });
  return {
    playlistAssignments: data,
    playlistAssignmentsLoading: loading,
    playlistAssignmentsError: error
  };
};